import { getSubscreen } from '../NotificationsUsageTrackers';
export const notificationUsageFactory = ({
  deliveryMethod,
  originName,
  templateId,
  typeId
}) => ({
  delivery_method: deliveryMethod,
  notification_origin: originName || 'no origin name',
  notification_template_id: templateId,
  notification_type: typeId,
  subscreen: getSubscreen()
});